export default __webpack_public_path__ + "static/media/0103.67deb9ac.jpg";